//import UIkit from "uikit";
//import Icons from "uikit/dist/js/uikit-icons";
//import swupSetup from "./swup-setup.js";
//import $ from 'jquery';
import barba from '@barba/core';

import 'bootstrap';

import './px-ready.js';

import "../../components/popup-searchform/jquery.autocomplete.min.js";

import '../../components/field-date/field-date.js';
import '../../components/same-height/same-height.js';
import '../../components/main-menu/main-menu.js';
import '../../components/image-compare/image-compare.js';
import '../../components/video/video.js';
import '../../components/form/form.js';
import '../../components/map/map.js';
import '../../components/scrollspy/scrollspy.js';
import "../../components/popup-searchform/popup-searchform.js";
import "../../components/banner-browser-upgrade/banner-browser-upgrade.js";
import "../../components/banner-cookies/banner-cookies.js";
import '../../components/header/header.js';

//import "../../components/menu-mobile-2-niveaux/menu-mobile-2-niveaux.js";
import "../../components/page-mode-switcher/page-mode-switcher.js";
import "../../components/share-with-opener/share-with-opener.js";
import "../../components/menu-opener/menu-opener.js";
import "../../components/search-count/search-count.js";

//import '../components/uk-accordion/accordion.js';

// loads the Icon plugin
//UIkit.use(Icons);
// components can be called from the imported UIkit reference
//UIkit.notification('Hello world.');


/*const options = {
  animateHistoryBrowsing: false,
  containers: ["#swup", "#wpadminbar"],
  cache: false,
  linkSelector:
    'a[href^="' +
    window.location.origin +
    '"]:not([data-no-swup]), a[href^="/"]:not([data-no-swup]), a[href^="#"]:not([data-no-swup]):not([href$="#"])',
  animationSelector: '[class*="px-trans-"]',
};

new swupSetup(options);*/

if (window.location.href.indexOf("wp-admin") > -1) {
}else{
  barba.init({
    transitions: [{
      name: 'default-transition',  
    }],
    views: [{
      namespace: 'home',
      beforeEnter() {
        // update the menu based on user navigation
        //menu.update();
        console.info('beforeenter')
      },
      afterEnter() {
        // refresh the parallax based on new page content
        //parallax.refresh();
        window.scrollTo(0,0);
        console.info('afterenter')
        var event;
        if (typeof Event === "function") {
          event = new Event("px-ready");
        } else {
          event = document.createEvent("Event");
          event.initEvent("px-ready", true, true);
        }
        window.dispatchEvent(new Event("px-ready"));
      }
    }],
    prevent: function ({ el, event, href }) {
      //el.classList && el.classList.contains('prevent')
      var r = false;
      if (/.pdf/.test(href.toLowerCase())) {
        //console.log('is-pdf');
        r = true;
      }
      if (href.includes("/wp-admin/") || href.includes("/uploads/")) {
        //console.log('is-admin');
        r = true;
      }
      if (!r && is_barba_avoid(href)) {
        r = true;
      }
      //console.log(r);
      return r;
    },
    //timeout: 20000,
    requestError: (trigger, action, url, response) => {
      console.log("requesterror");
      console.log(trigger);
      console.log(action);
      console.log(url);
      console.log(response);
      if (action === "enter") {
        window.location.reload();
      }
    },
    //window.dispatchEvent(new Event("px-ready"));
  })
}
function is_barba_avoid(href) {
  if (typeof barba_avoid !== "undefined") {
    for (var i in barba_avoid) {
      if (href.includes(barba_avoid[i])) {
        console.log('Avoid triggered')
        return true;
      }
    }
  }

  return false;
}